import type { CustomCellRendererProps } from 'ag-grid-react'

export function GridPercentCell(props: CustomCellRendererProps) {
  const value = props.value as number | null
  if (value == null)
    return <span className="text-sm text-foreground">—</span>

  return (
    <span className="text-sm text-foreground">{value.toFixed(2)}%</span>
  )
}
